export const reportDetailTable = [
  {
    prop: 'relicFromUserId',
    label: '建筑编号',
    width: 80
    // sortable: 'custom'
  },
  {
    prop: 'relicName',
    label: '名称',
    width: 210
  },
  {
    prop: 'relicDistrictEnum',
    label: '所属区域',
    width: 125
  },
  {
    prop: 'inspectorNickName',
    label: '巡查人',
    width: 145
  },
  {
    prop: 'createTime',
    label: '巡查时间',
    width: 135
    // sortable: 'custom'
  },
  {
    prop: 'inspectTypeEnum',
    label: '类型',
    width: 135
  },
  {
    prop: 'inspectStatusEnum',
    label: '巡查状态',
    width: 135
  }
];
